import Vue from 'vue';
import format from 'date-fns/format';

export const assignmentsListingService = {
  async retrieveAssignments(filters, sortOrder, paginationParameters, options = null) {
    let url;
    if (options && options.isProfileListing) {
      url = `/assignments/list/${options.referenceNumber}`;
    } else {
      url = `/assignments`;
    }
    return Vue.axios
      .get(url, {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters,
          ...sortOrder,
          ...paginationParameters,
          searchParam: filters.searchParam
        }
      })
      .then(response => response.data);
  },

  async bulkUpdateAssignments(bulkAction, assignmentRefs) {
    return Vue.axios
      .post('/assignments/bulk-update', {
        bulkAction,
        referenceNumbers: assignmentRefs
      })
      .then(response => response.data);
  },

  async retrieveFilteredRecordCount(filters, options) {
    const url =
      options && options.isProfileListing
        ? `/assignments/count-records/for-tes-employee`
        : `/assignments/count-records`;
    return Vue.axios
      .get(url, {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters,
          searchParam: filters.searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadAssignmentsXlsx(filters, sortOrder) {
    const response = await Vue.axios({
      url: `/assignments/xlsx`,
      method: 'GET',
      params: {
        ...filters.dateRangeFilters,
        ...filters.statusFilters,
        ...sortOrder
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Assignments-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },

  async getDashboardTotalSummary() {
    return Vue.axios.get('/assignments/total-summary').then(response => response.data);
  },
  async getDashboardPersonSummary() {
    return Vue.axios.get('/assignments/person-summary').then(response => response.data);
  },
  async getDashboardBranchSummary() {
    return Vue.axios.get('/assignments/branch-summary').then(response => response.data);
  },
  async getExecutiveDashboardBranchSummary() {
    return Vue.axios.get('/assignments/executive-branch-summary').then(response => response.data);
  }
};
